<nz-form-item *ngIf="visible" style="padding: 0; margin: 0">
  <nz-form-label *ngIf="labelVisible" style="white-space: normal;" [nzSpan]="labelSpan" [nzRequired]="required"
    [nzFor]="code" [nzTooltipTitle]="tooltip">
    {{ title }}
  </nz-form-label>
  <div nz-col [nzSpan]="fieldSpan" [ngSwitch]="widgetType">
    <app-array *ngSwitchCase="'ARRAY'" [field]="field"> </app-array>
    <app-avatar *ngSwitchCase="'AVATAR'" [field]="field"></app-avatar>
    <app-check *ngSwitchCase="'CHECK'" [field]="field"> </app-check>
    <app-ciiu *ngSwitchCase="'CIIU'" [field]="field"> </app-ciiu>
    <app-city *ngSwitchCase="'CITY'" [field]="field"> </app-city>
    <app-country *ngSwitchCase="'COUNTRY'" [field]="field"> </app-country>
    <app-date *ngSwitchCase="'DATE'" [field]="field"> </app-date>
    <app-daterange *ngSwitchCase="'DATERANGE'" [field]="field"> </app-daterange>
    <app-email *ngSwitchCase="'EMAIL'" [field]="field"> </app-email>
    <app-image *ngSwitchCase="'IMAGE'" [field]="field"></app-image>
    <app-input *ngSwitchCase="'INPUT'" [field]="field"> </app-input>
    <app-input-search *ngSwitchCase="'INPUTSEARCH'" [field]="field"> </app-input-search>
    <app-label *ngSwitchCase="'LABEL'" [field]="field"></app-label>
    <app-link *ngSwitchCase="'LINK'" [field]="field"></app-link>
    <app-map *ngSwitchCase="'MAP'" [field]="field"> </app-map>
    <app-message *ngSwitchCase="'MESSAGE'" [field]="field"> </app-message>
    <app-number *ngSwitchCase="'NUMBER'" [field]="field"> </app-number>
    <app-password *ngSwitchCase="'PASSWORD'" [field]="field"> </app-password>
    <app-pdfviewer *ngSwitchCase="'PDF'" [field]="field"></app-pdfviewer>
    <app-phone *ngSwitchCase="'PHONE'" [field]="field"> </app-phone>
    <app-progress *ngSwitchCase="'PROGRESS'" [field]="field"> </app-progress>
    <app-radio *ngSwitchCase="'RADIO'" [field]="field"> </app-radio>
    <app-select *ngSwitchCase="'LIST'" [field]="field"> </app-select>
    <app-html *ngSwitchCase="'HTML'" [field]="field"></app-html>
    <app-textarea *ngSwitchCase="'TEXTAREA'" [field]="field"> </app-textarea>
    <app-textnumber *ngSwitchCase="'TEXTNUMBER'" [field]="field"> </app-textnumber>
    <app-timerange *ngSwitchCase="'TIMERANGE'" [field]="field"> </app-timerange>
    <app-timerangeslider *ngSwitchCase="'TIMERANGESLIDER'" [field]="field"> </app-timerangeslider>
    <app-time *ngSwitchCase="'TIME'" [field]="field"> </app-time>
    <app-typeahead *ngSwitchCase="'TYPEAHEAD'" [field]="field"> </app-typeahead>
    <app-warning *ngSwitchCase="'WARNING'" [field]="field"></app-warning>
    <app-yearmonth *ngSwitchCase="'YEARMONTH'" [field]="field"></app-yearmonth>
  </div>
</nz-form-item>
